/**********************************************************
Chemical View
**********************************************************/
import ReportForm from './report_form';
import { fetchFields } from '../../actions/utils_actions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchCultivationReport } from '../../actions/report_actions';

class Reports extends Component {
  render() {
    return (
      <div className="row">
        <div className="col s12 m4 l3">
          <div className="card">
            <p className="reports-title">Reports Form</p>
            <ReportForm fetchFields={this.props.fetchFields} fields={this.props.fields} user={this.props.user}
              fetchCultivationReport={this.props.fetchCultivationReport} />
          </div>
        </div>
        <div className="col s12 m8 l9">

        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    fields: state.cultivation.utils.fields,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCultivationReport,
    fetchFields
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(Reports);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/reports/reports.js